export const useKeyboardHeight = () => 0;
